<template>
  <v-container>
    <v-form>
      <h2 class="pb-3 pt-2 pl-2" style="letter-spacing:normal;">{{$t('changepaswword')}}</h2>

      <v-container id="scroll-target" class="custom-form overflow-y-auto">
        <v-row class="mt-1">
          <v-col cols="4" sm="4" class="pb-n5">
            <v-text-field
              outlined
              :label="this.$t('oldpassword')"
              type="password"
              :rules="[rules.required]"
              v-model="formData.oldpassword"
              @input="updateValue"
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="4" sm="4" class="pb-n5 d-flex align-center">
            <span v-if="isOldPasswordErr" style="font-weight:bold;color:red;font-size:0.82rem;">{{ errOldPasswordMsg }}</span>
          </v-col>
        </v-row>

        <v-row class="mt-n4">
          <v-col cols="4" sm="4" class="pb-n5">
            <v-text-field
              outlined
              :label="this.$t('resetpassword.newpassword')"
              type="password"
              :rules="[rules.required]"
              v-model="formData.newpassword"
              @change="checkpassword"
              @input="updateValue"
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="4" sm="4" class="pb-n5 d-flex align-center">
            <div v-if="isErr" style="font-weight:bold;color:red;font-size:0.82rem;" v-html="errMsg"></div>
          </v-col>
        </v-row>

        <v-row class="mt-n4">
          <v-col cols="4" sm="4" class="pb-n5">
            <v-text-field
              outlined
              :label="this.$t('resetpassword.confirmnewpassword')"
              type="password"
              :rules="[rules.required]"
              v-model="formData.confirmnewpassword"
              @change="checkconfirmpassword"
              @input="updateValue"
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="4" sm="4" class="pb-n5 d-flex align-center">
            <span v-if="isConfirmErr" style="font-weight:bold;color:red;font-size:0.82rem;">{{$t('confirmpasswordisnotsamewithnewpassword')}}</span>
          </v-col>
        </v-row>

        <app-formbuttons
          v-bind:EditBool="false"
          v-on:SavePressed="buttonHandler"
          v-on:CancelPressed="$router.go(-1)"
        />

        <div v-if="isError">
          <app-error
            v-bind:parentError="{
              data: this.errmessage,
              isErr: this.isError,
            }"
            v-on:closeError="isError = $event"
          />
        </div>
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
// import moment from "moment";
//import GenericForm from '../../../generic/GridForm';
import ErrorDialog from "./ErrorDialog";

export default {
  props: {
    parentObject: Object,
  },

  components: {
    "app-error": ErrorDialog,
    //'app-genericform': GenericForm,
  },

  data() {
    return {
      rules: {
        required: (value) => !!value || this.$t('reportsparam.required'),
      },
      id: this.$route.params.id,
      formData: {
        oldpassword: "",
        newpassword: "",
        confirmnewpassword: "",
      },
      passpolicy: "",
      isError: false,
      errmessage: "",
      isErr: false,
      isConfirmErr: false,
      errMsg: "",
      isOldPasswordErr: false,
      errOldPasswordMsg: "",
      db: this.$route.params.db,
    };
  },

  methods: {
    CheckPasswordPolicy() {
      const vm = this;
      console.log(vm.id);
      if (vm.formData.newpassword != "") {
        this.$store.dispatch('post', {
          url:  "/policy/chkpwdpolicyNew", 
          payload: {
            userid: vm.id,
            password: vm.formData.newpassword,
          }, 
          headers: {db: vm.db}})
          .then((res) => {
            console.log(res);
            if (res.data.status != 200) {
              vm.isErr = !vm.isErr;
              vm.errMsg = res.data.error;
              vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
            }
          })
          .catch((err) => {
            vm.isErr = !vm.isErr;
            vm.errMsg = err;
            vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
          });
      }
    },
    buttonHandler() {
      const vm = this;
      if (!this.isErr && this.formData.oldpassword != "") {
        this.$store.dispatch('post', {
          url:  "/policy/changepasswordnew", 
          payload: {
            userid: vm.id,
            oldpassword: vm.formData.oldpassword,
            newpassword: vm.formData.newpassword,
          }, 
          headers: {db: vm.db}})
          .then((res) => {
            console.log(res);
            if (res.data.status == 200) {
              this.$dialog
                .alert(
                  this.$t('passwordchangesuccess')
                )
                .then((dialog) => {
                  console.log(dialog);
                  let db = this.$store.getters.db;
                  this.$store.dispatch("deleteToken");
                  //this.$router.replace("/" + this.$i18n.locale + "/home/" + db);
                  //then force reload page again
                  this.$router.replace("/" + this.$i18n.locale + "/home/" + db).then(() => {
                    window.location.reload()
                  })
                });
            } else if (res.data.status == 401) {
              vm.isOldPasswordErr = true;
              vm.errOldPasswordMsg = res.data.error;
              vm.$emit("error", {
                isOldPasswordErr: vm.isOldPasswordErr,
                errOldPasswordMsg: vm.errOldPasswordMsg,
              });
            } else {
              vm.isError = !vm.isError;
              vm.errmessage = res.data.error;
            }
          })
          .catch((err) => {
            vm.isErr = !vm.isErr;
            vm.errMsg = err;
            vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
          });
      }
    },
    updateValue() {
      this.isOldPasswordErr = false;
      this.$emit("input", {
        newpassword: this.formData.newpassword,
        oldpassword: this.formData.oldpassword,
        confirmnewpassword: this.formData.confirmnewpassword,
      });
    },
    checkpassword() {
      this.isErr = false;
      this.errMsg = "";
      this.CheckPasswordPolicy();
    },
    checkconfirmpassword() {
      this.isConfirmErr = false;
      if (this.formData.confirmnewpassword != this.formData.newpassword) {
        this.isConfirmErr = true;
      }
    },
  },
  errorHandler($event) {
    this.isError = $event.isError;
    this.errmessage = $event.errmessage;
  },

  mounted() {},
};
</script>